"use strict";
import { addBrowserClasses, debounce } from "./modules/_utils";
import "./modules/nav-main";
import "./modules/accordion-image-switcher";
import "./modules/custom-carousel";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

let debug = true

gsap.registerPlugin(ScrollTrigger);

if (document.querySelector('.home .accordion')) {
    if (document.querySelector('.home .accordion .acc-container')) {
        gsap.set(".home .accordion .acc-container", { x: 100 });
        ScrollTrigger.batch(".home .accordion .acc-container", {
            onEnter: batch => gsap.to(batch, { opacity: 1, x: 0, stagger: { each: 0.15, grid: [1, 3] }, overwrite: true }),
            onLeave: batch => gsap.set(batch, { opacity: 0, x: -100, overwrite: true }),
            onEnterBack: batch => gsap.to(batch, { opacity: 1, x: 0, stagger: 0.15, overwrite: true }),
            onLeaveBack: batch => gsap.set(batch, { opacity: 0, x: 100, overwrite: true })
        });
    }
}

if (document.querySelector('.page-template-employers .accordion')) {
    if (document.querySelector('.page-template-employers .accordion .acc-container')) {
        gsap.set(".page-template-employers .accordion .acc-container", { x: 100 });
        ScrollTrigger.batch(".page-template-employers .accordion .acc-container", {
            onEnter: batch => gsap.to(batch, { opacity: 1, x: 0, stagger: { each: 0.15, grid: [1, 3] }, overwrite: true }),
            onLeave: batch => gsap.set(batch, { opacity: 0, x: -100, overwrite: true }),
            onEnterBack: batch => gsap.to(batch, { opacity: 1, x: 0, stagger: 0.15, overwrite: true }),
            onLeaveBack: batch => gsap.set(batch, { opacity: 0, x: 100, overwrite: true })
        });
    }
}

if (document.querySelector('.page-template-vendor-management .accordion')) {
    if (document.querySelector('.page-template-vendor-management .accordion .acc-container')) {
        gsap.set(".page-template-vendor-management .accordion .acc-container", { x: 100 });
        ScrollTrigger.batch(".page-template-vendor-management .accordion .acc-container", {
            onEnter: batch => gsap.to(batch, { opacity: 1, x: 0, stagger: { each: 0.15, grid: [1, 3] }, overwrite: true }),
            onLeave: batch => gsap.set(batch, { opacity: 0, x: -100, overwrite: true }),
            onEnterBack: batch => gsap.to(batch, { opacity: 1, x: 0, stagger: 0.15, overwrite: true }),
            onLeaveBack: batch => gsap.set(batch, { opacity: 0, x: 100, overwrite: true })
        });
    }
}

if (document.querySelector('.page-template-vendor-management .mgmt .card')) {
    gsap.set(".page-template-vendor-management .mgmt .card", { y: 100 });
    ScrollTrigger.batch(".page-template-vendor-management .mgmt .card", {
        onEnter: batch => gsap.to(batch, { opacity: 1, y: 0, stagger: { each: 0.15, grid: [1, 3] }, overwrite: true }),
        onLeave: batch => gsap.set(batch, { opacity: 0, y: -100, overwrite: true }),
        onEnterBack: batch => gsap.to(batch, { opacity: 1, y: 0, stagger: 0.15, overwrite: true }),
        onLeaveBack: batch => gsap.set(batch, { opacity: 0, y: 100, overwrite: true })
    });
}

if (document.querySelector('.page-template-clinicians .how-it-works .accordion')) {
    if (document.querySelector('.page-template-clinicians .how-it-works .accordion .acc-container')) {
        gsap.set(".page-template-clinicians .how-it-works .accordion .acc-container", { x: 100 });
        ScrollTrigger.batch(".page-template-clinicians .how-it-works .accordion .acc-container", {
            onEnter: batch => gsap.to(batch, { opacity: 1, x: 0, stagger: { each: 0.15, grid: [1, 3] }, overwrite: true }),
            onLeave: batch => gsap.set(batch, { opacity: 0, x: -100, overwrite: true }),
            onEnterBack: batch => gsap.to(batch, { opacity: 1, x: 0, stagger: 0.15, overwrite: true }),
            onLeaveBack: batch => gsap.set(batch, { opacity: 0, x: 100, overwrite: true })
        });
    }
}

if (document.querySelector('.page-template-clinicians .key-features .accordion')) {
    if (document.querySelector('.page-template-clinicians .key-features .accordion .acc-container')) {
        gsap.set(".page-template-clinicians .key-features .accordion .acc-container", { x: -100 });
        ScrollTrigger.batch(".page-template-clinicians .key-features .accordion .acc-container", {
            onEnter: batch => gsap.to(batch, { opacity: 1, x: 0, stagger: { each: 0.15, grid: [1, 3] }, overwrite: true }),
            onLeave: batch => gsap.set(batch, { opacity: 0, x: 100, overwrite: true }),
            onEnterBack: batch => gsap.to(batch, { opacity: 1, x: 0, stagger: 0.15, overwrite: true }),
            onLeaveBack: batch => gsap.set(batch, { opacity: 0, x: -100, overwrite: true })
        });
    }
}


if (document.querySelector('.home .hero.parallax .bg')) {
    gsap.fromTo(document.querySelector('.home .hero.parallax .bg'), {
        backgroundPosition: () => "50% 0px"
    }, {
        backgroundPosition: () => `50% 200px`,
        ease: "none",
        scrollTrigger: {
            trigger: document.querySelector('.home .hero.parallax'),
            start: () => "top top",
            end: "bottom top",
            scrub: true,
            invalidateOnRefresh: true
        }
    });
}

if (document.querySelector('.home .intro .card')) {
    gsap.set(".home .intro .card", { y: 100 });
    ScrollTrigger.batch(".home .intro .card", {
        onEnter: batch => gsap.to(batch, { opacity: 1, y: 0, stagger: { each: 0.15, grid: [1, 3] }, overwrite: true }),
        onLeave: batch => gsap.set(batch, { opacity: 0, y: -100, overwrite: true }),
        onEnterBack: batch => gsap.to(batch, { opacity: 1, y: 0, stagger: 0.15, overwrite: true }),
        onLeaveBack: batch => gsap.set(batch, { opacity: 0, y: 100, overwrite: true })
    });
}

if (document.querySelector('.page-template-clinicians .intro .card')) {
    gsap.set(".page-template-clinicians .intro .card", { y: 100 });
    ScrollTrigger.batch(".page-template-clinicians .intro .card", {
        onEnter: batch => gsap.to(batch, { opacity: 1, y: 0, stagger: { each: 0.15, grid: [1, 3] }, overwrite: true }),
        onLeave: batch => gsap.set(batch, { opacity: 0, y: -100, overwrite: true }),
        onEnterBack: batch => gsap.to(batch, { opacity: 1, y: 0, stagger: 0.15, overwrite: true }),
        onLeaveBack: batch => gsap.set(batch, { opacity: 0, y: 100, overwrite: true })
    });
}

if (document.querySelector('.page-template-employers .mgmt .card')) {
    gsap.set(".page-template-employers .mgmt .card", { y: 100 });
    ScrollTrigger.batch(".page-template-employers .mgmt .card", {
        onEnter: batch => gsap.to(batch, { opacity: 1, y: 0, stagger: { each: 0.15, grid: [1, 3] }, overwrite: true }),
        onLeave: batch => gsap.set(batch, { opacity: 0, y: -100, overwrite: true }),
        onEnterBack: batch => gsap.to(batch, { opacity: 1, y: 0, stagger: 0.15, overwrite: true }),
        onLeaveBack: batch => gsap.set(batch, { opacity: 0, y: 100, overwrite: true })
    });
}

if (document.querySelector('.page-template-contact .parallax .bg')) {
    gsap.fromTo(document.querySelector('.page-template-contact .parallax .bg'), {
        backgroundPosition: () => "50% 50%"
    }, {
        backgroundPosition: () => `50% calc(50% + 200px)`,
        ease: "none",
        scrollTrigger: {
            trigger: document.querySelector('.page-template-contact .parallax'),
            start: () => "top top",
            end: "bottom top",
            scrub: true,
            invalidateOnRefresh: true
        }
    });
}

if (document.querySelector('.page-template-clinicians .parallax .bg')) {
    gsap.fromTo(document.querySelector('.page-template-clinicians .parallax .bg'), {
        backgroundPosition: () => "70% 100%"
    }, {
        backgroundPosition: () => `70% calc(100% + 200px)`,
        ease: "none",
        scrollTrigger: {
            trigger: document.querySelector('.page-template-clinicians .parallax'),
            start: () => "top top",
            end: "bottom top",
            scrub: true,
            invalidateOnRefresh: true
        }
    });
}

if (document.querySelector('.page-template-register .parallax .bg')) {
    gsap.fromTo(document.querySelector('.page-template-register .parallax .bg'), {
        backgroundPosition: () => "50% 0px"
    }, {
        backgroundPosition: () => `50% 200px`,
        ease: "none",
        scrollTrigger: {
            trigger: document.querySelector('.page-template-register .parallax'),
            start: () => "top top",
            end: "bottom top",
            scrub: true,
            invalidateOnRefresh: true
        }
    });
}

if (document.querySelector('.page-template-thankyou .parallax .bg')) {
    gsap.fromTo(document.querySelector('.page-template-thankyou .parallax .bg'), {
        backgroundPosition: () => "50% 0px"
    }, {
        backgroundPosition: () => `50% 200px`,
        ease: "none",
        scrollTrigger: {
            trigger: document.querySelector('.page-template-thankyou .parallax'),
            start: () => "top top",
            end: "bottom top",
            scrub: true,
            invalidateOnRefresh: true
        }
    });
}

if (document.querySelector('.page-template-employers .parallax .bg')) {
    gsap.fromTo(document.querySelector('.page-template-employers .parallax .bg'), {
        backgroundPosition: () => "50% 50%"
    }, {
        backgroundPosition: () => `50% calc(50% + 200px)`,
        ease: "none",
        scrollTrigger: {
            trigger: document.querySelector('.page-template-employers .parallax'),
            start: () => "top top",
            end: "bottom top",
            scrub: true,
            invalidateOnRefresh: true
        }
    });
}

if (document.querySelector('.page-template-get-started .parallax .bg')) {
    gsap.fromTo(document.querySelector('.page-template-get-started .parallax .bg'), {
        backgroundPosition: () => "50% 50%"
    }, {
        backgroundPosition: () => `50% calc(50% + 200px)`,
        ease: "none",
        scrollTrigger: {
            trigger: document.querySelector('.page-template-get-started .parallax'),
            start: () => "top top",
            end: "bottom top",
            scrub: true,
            invalidateOnRefresh: true
        }
    });
}

if (document.querySelector('.page-template-contact .parallax .bg')) {
    gsap.fromTo(document.querySelector('.page-template-contact .parallax .bg'), {
        backgroundPosition: () => "50% 50%"
    }, {
        backgroundPosition: () => `50% calc(50% + 200px)`,
        ease: "none",
        scrollTrigger: {
            trigger: document.querySelector('.page-template-contact .parallax'),
            start: () => "top top",
            end: "bottom top",
            scrub: true,
            invalidateOnRefresh: true
        }
    });
}


document.addEventListener("DOMContentLoaded", function() {

    if (document.getElementsByClassName("no-js")[0]) {
        document.getElementsByClassName("no-js")[0].classList.remove("no-js");
    }

    // Common functions
    addBrowserClasses();

    // Hubspot cookie settings links in footer
    const hubspotCookieSettings = document.getElementById('hs-footer-cookie-settings');
    if (hubspotCookieSettings) {
        hubspotCookieSettings.addEventListener('click', function(e) {
            e.preventDefault();
            var _hsp = window._hsp = window._hsp || [];
            _hsp.push(['showBanner']);
        });
    }

    // Get session storage value
    if (sessionStorage.getItem("referrerSite") === null) {
        var referrerSite = document.referrer;
        sessionStorage.setItem("referrerSite", referrerSite);
    }


    /**
     *
     *
     * Accordion
     *
     *
     */

    const faqItems = document.querySelectorAll('.faq-accordion .acc-container');
    faqItems.forEach(item => {
        item.querySelector('.acc-toggle').addEventListener('click', function() {
            faqItems.forEach(other => { if (other !== item) other.classList.remove('active'); });
            item.classList.toggle('active');
        });
    });

    const accItems = document.querySelectorAll('.accordion:not(.faq-accordion) .acc-container');
    const imgItems = document.querySelectorAll('.img-container .acc-graphic');
    const howItWorks = document.querySelector('.how-it-works');
    const keyFeatures = document.querySelector('.key-features');

    // create arrays from nodelists to get the indexes and set unique data-attrs
    const arr1 = Array.prototype.slice.call(accItems);
    const arr2 = Array.prototype.slice.call(imgItems);

    accItems.forEach(i => {
        i.setAttribute('data-value', arr1.indexOf(i));
    })
    imgItems.forEach(i => {
        i.setAttribute('data-value', arr2.indexOf(i));
    })


    const addClasses = (elem) => {
        accItems.forEach(e => {

            e.addEventListener('click', function() {
                const parent = this.closest("section");

                // only fire if element clicked is inside section
                if (elem === parent) {

                    // remove all 'active' classes from siblings + add to target element
                    for (let sibling of this.parentNode.children) {
                        sibling.classList.remove('active');
                    }
                    this.classList.toggle('active');

                    // only grab the .acc-graphic image elements that are inside the section
                    const sectionImgItems = elem.querySelectorAll('.acc-graphic')
                    sectionImgItems.forEach(i => {
                        i.dataset.value === e.dataset.value ? i.classList.add('show') : i.classList.remove('show');
                    })

                }

            })

        })

    }

    addClasses(howItWorks);
    addClasses(keyFeatures);


});
